<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-code-branch"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="groupForm" :labelColumnSize="3">
      <FormRow label="Name">
        <FormInputText v-model="groupData.name" field="name" />
      </FormRow>
      <FormRow label="Type">
        <FormSelect v-model="groupData.type" field="type" :options="ResourceGroupTypeLookup" />
      </FormRow>
      <FormRow label="Highlight Colour" helpTip="Highlight colour for the group used in the calendar maps for task management">
        <FormColourTag v-model="groupData.highlightColour" field="highlightColour" />
      </FormRow>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { ResourceGroupTypes, ResourceGroupTypeLookup } from '@/store/types'

export default {
  name: 'ResourceGroupDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    resourceGroupId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      groupData: {
      },
      groupForm: {},
      submitting: false
    }
  },
  created() {
    this.ResourceGroupTypes = ResourceGroupTypes
    this.ResourceGroupTypeLookup = ResourceGroupTypeLookup
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Resource Group' : 'Edit Resource Group'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    }
  },
  methods: {
    show(resourceGroup) {
      // Reset form
      this.groupData = {
        name: '',
        type: '',
        highlightColour: null
      }
      this.groupForm = {}
      this.submitting = false

      if(resourceGroup != null) {
        this.groupData = _.cloneDeep(resourceGroup)
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var groupData = _.cloneDeep(this.$data.groupData)

      if(this.isCreateMode) {
        this.$apiService.tasksService.createResourceGroup(groupData)
        .then(response => {
          this.submitting = false
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.groupForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.tasksService.updateResourceGroup(groupData.id, groupData)
        .then(response => {
          this.submitting = false
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.groupForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>